import { render, staticRenderFns } from "./UpdateClassPlan.vue?vue&type=template&id=2f53ac0f&scoped=true&"
import script from "./UpdateClassPlan.vue?vue&type=script&lang=js&"
export * from "./UpdateClassPlan.vue?vue&type=script&lang=js&"
import style0 from "./UpdateClassPlan.vue?vue&type=style&index=0&id=2f53ac0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f53ac0f",
  null
  
)

export default component.exports